import type React from 'react';

import type { DepartmentId } from '@vlabs/api/artemy/model';
import { DepartmentGeoZone } from '@vlabs/monokit/widgets/departments/department-geo-zone';

import { DepartmentHint } from './department-hint/DepartmentHint';
import st from './DepartmentAside.module.sass';
import { useDepartmentsPageTranslation } from '../i18n';

interface DepartmentAsideProps {
  departmentId: DepartmentId;
}

function DepartmentAside({
  departmentId,
}: DepartmentAsideProps): React.JSX.Element {
  const { t } = useDepartmentsPageTranslation();

  return (
    <div className={st.Root}>
      <div className={st.GeoZoneSection}>
        <h6>{t('geo_zone.title')}</h6>

        <DepartmentGeoZone
          className={st.GeoZone}
          departmentId={departmentId}
        />
      </div>

      <DepartmentHint />
    </div>
  );
}

export { DepartmentAside };
